import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Select } from '~/componentes/CustomForm';

import { Container } from './styles';
import { Materialize } from '~/styles/materializeGrid';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
import GroupAcoordion from '~/componentes/GroupAcoordion';
import FindOrCreateUser from '~/componentes/FindOrCreateUser';

function CreateContent({ unidades }) {
  const [modulos, setModulos] = useState([]);
  const [gruposPerfis, setGruposPerfis] = useState([]);
  const [tiposContrato, setTiposContrato] = useState([]);
  const [usuario, setUsuario] = useState();
  const [tipo, setTipo] = useState('ADM');
  const [grupoPerfil, setGrupoPerfil] = useState(undefined);
  const [tipoContrato, setTipoContrato] = useState(undefined);

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let response;

        response = await api.post('/signed/empresa/administracao/gerenciamento/perfil', {
          ...data,
          usuario,
          tipo,
          idGrupoPerfil: grupoPerfil?.id,
          idTipoContrato: tipoContrato?.id,
        });

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao cadastrar esse Grupo de Usuário, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja cadastrar esse Grupo de Usuário?`,
        successModal: `Grupo de Usuário cadastrado com sucesso!`,
      },
    );
  }

  useEffect(() => {
    api
      .get('/signed/geral/acessos/check', { params: { tipo: 'ADM' } })
      .then(response => setModulos(response.data));
    api
      .get('/signed/empresa/administracao/gerenciamento/gruposperfis', {
        params: { tipo: 'ADM', acesso: true },
      })
      .then(response => setGruposPerfis(response.data));
    api
      .get('/signed/empresa/administracao/gerenciamento/tiposcontrato')
      .then(response => setTiposContrato(response.data));
  }, []);

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row header">
          <p className="h-descricao">
            Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios
          </p>
        </div>
        <FindOrCreateUser setter={setUsuario} />
        <div className="row">
          <Label title="Tipo *" className="col s3 m3 l3">
            <Select
              isNumber
              list={{
                list: [
                  { tipo: 'ADM', nome: 'Admin' },
                  { tipo: 'DIR', nome: 'Diretor' },
                  { tipo: 'GER', nome: 'Gerente' },
                  { tipo: 'COM', nome: 'Comercial' },
                  { tipo: 'COR', nome: 'Coordenador' },
                  { tipo: 'ANA', nome: 'Analista' },
                ],
                value: 'tipo',
                label: 'nome',
              }}
              name="tipo"
              onChange={e => {
                const v = e.currentTarget.value;
                setTipo(v);
              }}
            />
          </Label>
          <Label title="Grupo *" className="col s3 m3 l3">
            <Select
              isNumber
              list={{ list: gruposPerfis, value: 'id', label: 'nome' }}
              name="idGrupoPerfil"
              onChange={e => {
                const v = e?.currentTarget?.value || 0;
                setGrupoPerfil(gruposPerfis.find(o => o?.id === parseInt(v)));
              }}
              firstOption
              required="true"
            />
          </Label>
          <Label title="Unidade *" className="col s3 m3 l3">
            <Select
              isNumber
              list={{ list: unidades, value: 'id', label: 'nome' }}
              name="idUnidade"
              firstOption
              required="true"
            />
          </Label>
          <Label title="Tipo Contrato" className="col s3 m3 l3">
            <Select
              isNumber
              list={{ list: tiposContrato, value: 'id', label: 'sigla' }}
              name="idTipoContrato"
              onChange={e => {
                const v = e?.currentTarget?.value || 0;
                setTipoContrato(tiposContrato.find(o => o?.id === parseInt(v)));
              }}
              firstOption
            />
          </Label>
        </div>
        <div className="row">
          <p className="col s12 m12 l12 text-separador">
            Selecione o Tipo e Marque os Acessos do Perfil abaixo:
          </p>
        </div>
        <div className="row">
          {modulos.length > 0 && (
            <GroupAcoordion
              defaultSelect={grupoPerfil?.acessos || []}
              title={'Acessos '}
              name={'acessos'}
              itens={modulos}
            />
          )}
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateContent;
